import script from "./TicketPayoutContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./TicketPayoutContent.vue?vue&type=script&setup=true&lang=ts"

import "./TicketPayoutContent.vue?vue&type=style&index=0&id=f3cca382&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f3cca382"]])

export default __exports__